import Vue, { PluginFunction } from 'vue'
import Noty from 'noty'

const defaults: Noty.Options = {
    layout: 'bottomCenter',
    theme: 'relax',
    timeout: 1500,
    animation: {
        open: 'fade-in-up',
        close: 'fade-out-down'
    }
}

const notice: PluginFunction<Noty.Options> = (vue: typeof Vue, options?: Noty.Options) => {
    vue.prototype.$notice = (opts?: Noty.Options) => {
        const noty = new Noty({ ...defaults, ...options, ...opts })
        noty.show()
        return noty
    }

    vue.prototype.$error = (opts?: Noty.Options) =>
        vue.prototype.$notice({ ...opts, type: 'error' })

    vue.prototype.$warning = (opts?: Noty.Options) =>
        vue.prototype.$notice({ ...opts, type: 'warning' })

    vue.prototype.$success = (opts?: Noty.Options) =>
        vue.prototype.$notice({ ...opts, type: 'success' })

    vue.prototype.$info = (opts?: Noty.Options) =>
        vue.prototype.$notice({ ...opts, type: 'info' })
}

export default notice
